import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const taskCategory = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/task-category',
    app: 'task',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task-category' }
    ),
    { }
  )
)()

export { taskCategory, TYPES }
